var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRescheduleSession(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42305_805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 3.3332H5.66699C4.26686 3.3332 3.5668 3.3332 3.03202 3.60568C2.56161 3.84536 2.17916 4.22782 1.93948 4.69822C1.66699 5.233 1.66699 5.93307 1.66699 7.3332V14.3332C1.66699 15.7333 1.66699 16.4334 1.93948 16.9682C2.17916 17.4386 2.56161 17.821 3.03202 18.0607C3.5668 18.3332 4.26686 18.3332 5.66699 18.3332H12.667C14.0671 18.3332 14.7672 18.3332 15.302 18.0607C15.7724 17.821 16.1548 17.4386 16.3945 16.9682C16.667 16.4334 16.667 15.7333 16.667 14.3332V10.8332M6.66697 13.3332H8.06242C8.47007 13.3332 8.6739 13.3332 8.86571 13.2871C9.03577 13.2463 9.19835 13.179 9.34747 13.0876C9.51566 12.9845 9.65979 12.8404 9.94804 12.5521L17.917 4.5832C18.6073 3.89284 18.6073 2.77355 17.917 2.0832C17.2266 1.39284 16.1073 1.39284 15.417 2.0832L7.44802 10.0521C7.15977 10.3404 7.01564 10.4845 6.91257 10.6527C6.82119 10.8018 6.75385 10.9644 6.71302 11.1345C6.66697 11.3263 6.66697 11.5301 6.66697 11.9378V13.3332Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42305_805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRescheduleSession);
export default __webpack_public_path__ + "static/media/RescheduleSession.8cd9b356efb8203307a5fe9e95344a98.svg";
export { ForwardRef as ReactComponent };